import enkLogo from "../assets/enk-logo.svg"

export default function EnkLogo() {
  return <img src={enkLogo} alt="enk logo" className="h-6 w-auto" />
}
